import {
  FIELD_DEFAULT_NAME,
  GENERAL_CARGO,
  getCommonStateByProp,
  IDENTIFICATION_TYPE_1,
  IDENTIFICATION_TYPE_3,
  IDENTIFICATION_TYPE_4, IDENTIFICATION_TYPE_DEFAULT,
  INTELLIGENT_DOCUMENT_SOURCE_12,
  INTELLIGENT_DOCUMENT_SOURCE_13, INTELLIGENT_DOCUMENT_SOURCE_16,
  INTELLIGENT_DOCUMENT_SOURCE_4,
  INTELLIGENT_DOCUMENT_SOURCE_5,
  INTELLIGENT_DOCUMENT_SOURCE_6,
  INTELLIGENT_DOCUMENT_SOURCE_7,
  INTELLIGENT_DOCUMENT_SOURCE_REMOTE_AE,
  INTELLIGENT_DOCUMENT_SOURCE_REMOTE_SE,
  OCR_FIELD_CARGO_TYPE,
  OCR_FIELD_CHANNEL_BOOK_NOTE,
  OCR_FIELD_IF_REQUIRED_SAVE_JOB,
  OCR_FIELD_IF_SAME_FROM_BOOK_NOTE,
  OCR_FIELD_IF_SAME_FROM_FROM_MAIL,
  OCR_FIELD_MAP,
  SENDING_0,
  SENDING_1,
  SENDING_2,
  SENDING_4, SENDING_5
} from '@/class/cargo/model/parameters/SystemConstants'
import { isContractExpiredForbidCreateJobs } from '@/api/partner/contract'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import StrUtils from '@/utils/StrUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { airlineCompanyMatch, namePrefixMatch } from '@/api/company'
import { isNumber } from '@/utils/validate'
import DateUtils from '@/utils/dateUtils'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { CARGOTYPE_GENERAL, DIRECT } from '@/class/cargo/model/parameters/ImportConstants'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import * as ImportConstants from '@/class/cargo/model/parameters/ImportConstants'

class OcrUtils {
  // private static let INSTANCE:ColumnUtils = null;
  // private let resourceManager:IResourceManager = ResourceManager.getInstance();
  // private let dateFormatter:DateFormatter = new DateFormatter();
  // private let LOGGER:ILogger = Log.getLogger("ColumnUtils");

  // eslint-disable-next-line no-useless-constructor

  constructor() {

  }

  /**
   * 获取字段label
   */
  static getOcrFieldLabel(code, iChannel) {
    const obj = OCR_FIELD_MAP.get(code)
    if (obj instanceof Map) {
      if (obj.has(iChannel)) {
        return obj.get(iChannel)
      } else {
        return obj.get(FIELD_DEFAULT_NAME)
      }
    } else {
      return obj
    }
  }

  // 根据【取值规则】组装finalResultJson
  static getFinalResultJson(resultJson, emailResultJson, otherField, fieldDefineMap) {
    const finalResultJson = {}
    for (const fieldDetail of otherField.ocrOtherFieldDetails) {
      if (!fieldDetail.ifCheck || !fieldDetail.channel) {
        // 未开启配置，则默认取【托书】
        finalResultJson[fieldDetail.code] = resultJson[fieldDetail.code]
      } else {
        if (!fieldDefineMap[fieldDetail.code].ifExtraField) {
          // 识别字段
          if (fieldDetail.channel.indexOf(',') >= 0) {
            // 渠道选中：托书、邮件
            if (resultJson[fieldDetail.code] !== emailResultJson[fieldDetail.code]) {
              // 托书 与 邮件 不一致
              if (fieldDetail.isSame === OCR_FIELD_IF_SAME_FROM_BOOK_NOTE.code) {
                // 以托书为准
                finalResultJson[fieldDetail.code] = resultJson[fieldDetail.code]
              } else if (fieldDetail.isSame === OCR_FIELD_IF_SAME_FROM_FROM_MAIL.code) {
                finalResultJson[fieldDetail.code] = emailResultJson[fieldDetail.code]
              }
            } else {
              // 托书 与 邮件 一致
              finalResultJson[fieldDetail.code] = resultJson[fieldDetail.code]
            }
          } else if (fieldDetail.channel === OCR_FIELD_CHANNEL_BOOK_NOTE.code) {
            // 渠道选中：托书
            finalResultJson[fieldDetail.code] = resultJson[fieldDetail.code]
          } else {
            // 渠道选中：邮件
            finalResultJson[fieldDetail.code] = emailResultJson[fieldDetail.code]
          }
        }
        if (!finalResultJson[fieldDetail.code] && fieldDetail.defaultValue) {
          // 取为空默认值
          finalResultJson[fieldDetail.code] = fieldDetail.defaultValue
        }
      }
    }
    return finalResultJson
  }

  // 字段校验
  static async fieldValid(view) {
    // 委托单位合同到期，不能创建业务校验
    const cmpIdxList = new Set()
    for (let i = 0; i < view.resultArray.length; ++i) {
      const jobJson = view.resultArray[i].text.data.jobJson
      if (jobJson.customerId) {
        cmpIdxList.add(jobJson.customerId)
      }
    }
    const contractExpiredCmpIdxList = []
    if (cmpIdxList.size > 0) {
      await isContractExpiredForbidCreateJobs(Array.from(cmpIdxList)).then(res => {
        if (res.data && res.data.length > 0) {
          contractExpiredCmpIdxList.push(...res.data)
        }
      })
    }
    if (view.otherField.ocrOtherFieldDetails && view.otherField.ocrOtherFieldDetails.length > 0) {
      const fieldValidResultsMap = new Map()
      // 必填项 校验
      const requiredFieldDetails = view.otherField.ocrOtherFieldDetails.filter(item => !!item.ifRequired && !!item.ifCheck)
      if (requiredFieldDetails && requiredFieldDetails.length > 0) {
        for (let i = 0; i < view.resultArray.length; ++i) {
          const result = view.resultArray[i]
          const fieldValidResultByBook = {
            index: i,
            data: []
          }
          const job = result.text.data.jobJson
          for (const fieldDetail of requiredFieldDetails) {
            // 保存业务必填校验、订舱必填校验
            if (fieldDetail.ifRequired.split(',').length > 1 || fieldDetail.ifRequired === OCR_FIELD_IF_REQUIRED_SAVE_JOB.code || job.ifAutoBooking) {
              if (!job[fieldDetail.code] || (Array.isArray(job[fieldDetail.code]) && job[fieldDetail.code].length === 0)) {
                fieldValidResultByBook.data.push({
                  fieldName: OcrUtils.getOcrFieldLabel(fieldDetail.code, view.useCase),
                  exceptionReason: view.$t('queryJob.CannotBeEmpty')
                })
              } else if (fieldDetail.code === SystemConstants.OCR_FIELD_CUSTOMER_ID.code) {
                if (contractExpiredCmpIdxList.indexOf(job[fieldDetail.code]) > -1) {
                  fieldValidResultByBook.data.push({
                    fieldName: OcrUtils.getOcrFieldLabel(fieldDetail.code, view.useCase),
                    exceptionReason: view.$t('Message.ContractExpireCannotCreated')
                  })
                }
              }
            }
          }
          if (fieldValidResultByBook.data.length > 0) {
            fieldValidResultsMap.set(i, fieldValidResultByBook)
          }
        }
      }

      if (fieldValidResultsMap.size > 0) {
        view.fieldValidDialog.fieldValidResults = Array.from(fieldValidResultsMap.values()).sort((a, b) => a.index - b.index)
        view.fieldValidDialog.visible = true
        return false
      }
    }
    return true
  }

  // 委托单位
  static async mapperCustomerId(job, resultJson, view, methodParams) {
    job.customerId = 0
    if (!StrUtils.isEmpty(resultJson.customerId)) {
      // 用解析值 匹配 代码
      let customerId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'cnShortName', resultJson.customerId, 'cmpIdx', null, null, methodParams)
      if (!customerId) {
        // 用解析值 匹配 英文名
        customerId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'englishName', resultJson.customerId, 'cmpIdx', null, null, methodParams)
        if (!customerId || Number(customerId) <= 0) {
          // 用解析值 匹配 中文名
          customerId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'chineseName', resultJson.customerId, 'cmpIdx', null, null, methodParams)
          if (!customerId || Number(customerId) <= 0) {
            // 用解析值 匹配 中文名
            customerId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'shortName', resultJson.customerId, 'cmpIdx', null, null, methodParams)
            if (!customerId || Number(customerId) <= 0) {
              const mapperKey = SystemConstants.OCR_MAPPER_TYPE_CUSTOMER.code + '_' + view.useCase + '_' + resultJson.customerId
              const newMapperVal = view.customer.get(mapperKey)
              if (newMapperVal) {
                // 用映射值 匹配 代码
                customerId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'cnShortName', newMapperVal, 'cmpIdx', null, null, methodParams)
                if (!customerId || Number(customerId) <= 0) {
                  // 用映射值 匹配 英文名
                  customerId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'englishName', newMapperVal, 'cmpIdx', null, null, methodParams)
                  if (!customerId || Number(customerId) <= 0) {
                    // 用映射值 匹配 中文名
                    customerId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'chineseName', newMapperVal, 'cmpIdx', null, null, methodParams)
                    if (!customerId || Number(customerId) <= 0) {
                      // 用映射值 匹配 中文名
                      customerId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'shortName', newMapperVal, 'cmpIdx', null, null, methodParams)
                    }
                  }
                }
              }
            }
          }
        }
      }
      job.customerId = customerId || 0
      // 委托单位 前缀模糊匹配
      if (!job.customerId) {
        namePrefixMatch({ companyName: resultJson.customerId, ...methodParams }).then(res => {
          job.customerId = res.data
        })
      }
    }
  }

  // 货物类型
  static async mapperCargoType(job, resultJson, view, methodParams) {
    job.cargoType = ''
    if (!StrUtils.isEmpty(resultJson.cargoType)) {
      let cargoTypeStr = resultJson.cargoType
      if (GENERAL_CARGO === resultJson.cargoType) {
        cargoTypeStr = CARGOTYPE_GENERAL.code
      }
      // 用解析值 匹配 代码
      let cargoType = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_CargoType, 'code', cargoTypeStr, 'code', null, null, methodParams)
      if (!cargoType) {
        // 用解析值 匹配 英文名
        cargoType = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_CargoType, 'englishName', cargoTypeStr, 'code', null, null, methodParams)
        if (!cargoType) {
          // 用解析值 匹配 中文名
          cargoType = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_CargoType, 'chineseName', cargoTypeStr, 'code', null, null, methodParams)
        }
      }
      job.cargoType = cargoType || ''
    }
  }

  // 航空公司
  static async mapperAirlineCompany(job, resultJson, view, methodParams) {
    job.carrierId = 0
    if (!StrUtils.isEmpty(resultJson.carrierId)) {
      // 用解析值 匹配 代码
      let carrierId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'cnShortName', resultJson.carrierId, 'cmpIdx', null, null, methodParams)
      carrierId = this.checkOfficeId(carrierId, view)
      if (!carrierId) {
        // 用解析值 匹配 英文名
        carrierId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'englishName', resultJson.carrierId, 'cmpIdx', null, null, methodParams)
        carrierId = this.checkOfficeId(carrierId, view)
        if (!carrierId || Number(carrierId) <= 0) {
          // 用解析值 匹配 中文名
          carrierId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'chineseName', resultJson.carrierId, 'cmpIdx', null, null, methodParams)
          carrierId = this.checkOfficeId(carrierId, view)
          if (!carrierId || Number(carrierId) <= 0) {
            // 用解析值 匹配 简称
            carrierId = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Company, 'shortName', resultJson.carrierId, 'cmpIdx', null, null, methodParams)
            carrierId = this.checkOfficeId(carrierId, view)
          }
        }
      }
      job.carrierId = carrierId || 0
      // Airline Code、IATA CODE
      if (!job.carrierId) {
        airlineCompanyMatch({ code: resultJson.carrierId, currentBranchId: view.$store.getters.currentOfficeId, ...methodParams }).then(res => {
          job.carrierId = res.data
        })
      }
    }
  }

  static async mapperLoadingTerm(job, resultJson) {
    job.loadingTerm = ''
    if (!StrUtils.isEmpty(resultJson.loadingTerm)) {
      let state = SystemConstants.getCommonStateByProp('code', resultJson.loadingTerm, AirExportConstants.SUFFY_TYPES)
      if (state) {
        job.loadingTerm = state.code
        return
      }
      state = SystemConstants.getCommonStateByProp('englishName', resultJson.loadingTerm, AirExportConstants.SUFFY_TYPES)
      if (state) {
        job.loadingTerm = state.code
        return
      }
      state = SystemConstants.getCommonStateByProp('chineseName', resultJson.loadingTerm, AirExportConstants.SUFFY_TYPES)
      if (state) {
        job.loadingTerm = state.code
        return
      }
    }
  }

  static checkOfficeId(carrierId, view) {
    if (carrierId && carrierId > 0) {
      const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', carrierId)
      if (company && ((company.branchId !== 1 && company.branchId !== view.$store.getters.currentOfficeId &&
          (!company.multipleBranchId || (company.multipleBranchId && !company.multipleBranchId.split(',').includes(String(view.$store.getters.currentOfficeId))))))) {
        carrierId = 0
      }
    }
    return carrierId
  }

  static mapperDate(field, obj, resultJson, format) {
    let dateStr = resultJson[field]
    // 开航日期无年份，则默认当前年份
    if (dateStr && dateStr.length > 4) {
      const years = dateStr.substring(0, 4)
      if (!isNumber(years)) {
        dateStr = new Date().getFullYear() + '-' + dateStr
      }
    }
    if (dateStr) {
      dateStr = dateStr.replaceAll(/[年月日号.]/g, '-')
      let date = DateUtils.toDateStrByFormat(dateStr, format)
      if (!date && dateStr.length > 8) {
        date = ColumnUtils.dateTimeLabelFunc(dateStr)
      }
      obj[field] = date || ''
    }
  }

  // 运费条款
  static mapperPaymentTerm(job, resultJson, view) {
    if (!StrUtils.isEmpty(resultJson.paymentTermMBL)) {
      if (['PP', 'PREPAID'].indexOf(resultJson.paymentTermMBL.toUpperCase()) > -1) {
        resultJson.paymentTermMBL = 'FREIGHT PREPAID'
      } else if (['CC', 'COLLECT'].indexOf(resultJson.paymentTermMBL.toUpperCase()) > -1) {
        resultJson.paymentTermMBL = 'FREIGHT COLLECT'
      } else if (['3P', '3RD', 'THIRD PAID'].indexOf(resultJson.paymentTermMBL.toUpperCase()) > -1) {
        resultJson.paymentTermMBL = '3P'
      }
      // 用解析值 匹配 代码
      let paymenTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_PaymentTerm, 'code', resultJson.paymentTermMBL, 'code')
      if (!paymenTerm) {
        // 用解析值 匹配 英文名
        paymenTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_PaymentTerm, 'name', resultJson.paymentTermMBL, 'code')
        if (!paymenTerm) {
          // 用解析值 匹配 中文名
          paymenTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_PaymentTerm, 'localName', resultJson.paymentTermMBL, 'code')
          if (!paymenTerm) {
            const mapperKey = SystemConstants.OCR_MAPPER_TYPE_PAYMENT_TERM.code + '_' + view.useCase + '_' + resultJson.paymentTermMBL
            const newMapperVal = view.paymentTerm.get(mapperKey)
            if (newMapperVal) {
              // 用映射值 匹配 代码
              paymenTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_PaymentTerm, 'code', newMapperVal, 'code')
              if (!paymenTerm) {
                // 用映射值 匹配 英文名
                paymenTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_PaymentTerm, 'name', newMapperVal, 'code')
                if (!paymenTerm) {
                  // 用映射值 匹配 中文名
                  paymenTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_PaymentTerm, 'localName', newMapperVal, 'code')
                }
              }
            }
          }
        }
      }
      // job.paymentTermHBL = paymenTerm || ''
      job.paymentTermMBL = paymenTerm || ''
    }
  }

  // 贸易条款
  static mapperIncoTerm(job, resultJson, view) {
    if (!StrUtils.isEmpty(resultJson.incoTerm)) {
      // 用解析值 匹配 代码
      let incoTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_IncoTerm, 'code', resultJson.incoTerm, 'code')
      if (!incoTerm) {
        // 用解析值 匹配 英文名
        incoTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_IncoTerm, 'name', resultJson.incoTerm, 'code')
        if (!incoTerm) {
          // 用解析值 匹配 中文名
          incoTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_IncoTerm, 'localName', resultJson.incoTerm, 'code')
          if (!incoTerm) {
            const mapperKey = SystemConstants.OCR_MAPPER_TYPE_INCO_TERM.code + '_' + view.useCase + '_' + resultJson.incoTerm
            const newMapperVal = view.incoTerm.get(mapperKey)
            if (newMapperVal) {
              // 用映射值 匹配 代码
              incoTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_IncoTerm, 'code', newMapperVal, 'code')
              if (!incoTerm) {
                // 用映射值 匹配 英文名
                incoTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_IncoTerm, 'name', newMapperVal, 'code')
                if (!incoTerm) {
                  // 用映射值 匹配 中文名
                  incoTerm = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_IncoTerm, 'localName', newMapperVal, 'code')
                }
              }
            }
          }
        }
      }
      job.incoTerm = incoTerm || ''
    }
  }

  // Currency
  static mapperCurrency(obj, resultJson) {
    if (!StrUtils.isEmpty(resultJson.currency)) {
      // 用解析值 匹配 代码
      let currency = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Currency, 'code', resultJson.incoTerm, 'code')
      if (!currency) {
        // 用解析值 匹配 英文名
        currency = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Currency, 'name', resultJson.incoTerm, 'code')
        if (!currency) {
          // 用解析值 匹配 中文名
          currency = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Currency, 'localName', resultJson.incoTerm, 'code')
        }
      }
      obj.currency = currency || ''
    }
  }

  // 操作模式
  static async mapperOperateType(job, resultJson) {
    job.operateType = ''
    if (!StrUtils.isEmpty(resultJson.operateType)) {
      let state = SystemConstants.getCommonStateByProp('code', resultJson.operateType, ImportConstants._cargoTypeAirInputList)
      if (state) {
        job.operateType = state.code
        return
      }
      state = SystemConstants.getCommonStateByProp('englishName', resultJson.operateType, ImportConstants._cargoTypeAirInputList)
      if (state) {
        job.operateType = state.code
        return
      }
      state = SystemConstants.getCommonStateByProp('chineseName', resultJson.operateType, ImportConstants._cargoTypeAirInputList)
      if (state) {
        job.operateType = state.code
        return
      }
    }
    job.operateType = DIRECT.code
  }

  // 起运港 中转港 卸货港 交货地
  static mapperPort(code = '', jsonCode = '', job, resultJson, view, cacheKey) {
    if (!code) return
    if (!resultJson[jsonCode]) return
    // 用解析值 匹配 代码
    let portCode = ColumnUtils.resolveColumnLabelIgnoreCase(cacheKey, 'code', resultJson[jsonCode], 'code')
    if (!portCode) {
      // 用解析值 匹配 英文名
      portCode = ColumnUtils.resolveColumnLabelIgnoreCase(cacheKey, 'englishName', resultJson[jsonCode], 'code')
      if (!portCode) {
        // 用解析值 匹配 中文名
        portCode = ColumnUtils.resolveColumnLabelIgnoreCase(cacheKey, 'chineseName', resultJson[jsonCode], 'code')
        if (!portCode) {
          const mapperKey = SystemConstants.OCR_MAPPER_TYPE_PORT.code + '_' + view.useCase + '_' + resultJson[jsonCode]
          const newMapperVal = view.port.get(mapperKey)
          if (newMapperVal) {
            // 用映射值 匹配 代码
            portCode = ColumnUtils.resolveColumnLabelIgnoreCase(cacheKey, 'code', newMapperVal, 'code')
            if (!portCode) {
              // 用映射值 匹配 英文名
              portCode = ColumnUtils.resolveColumnLabelIgnoreCase(cacheKey, 'englishName', newMapperVal, 'code')
              if (!portCode) {
                // 用映射值 匹配 中文名
                portCode = ColumnUtils.resolveColumnLabelIgnoreCase(cacheKey, 'chineseName', newMapperVal, 'code')
              }
            }
          }
        }
      }
    }
    // 只比较','前面的部分；比如：shanghai 匹配 shanghai,china
    if (!portCode) {
      // 用解析值 匹配 代码
      portCode = ColumnUtils.resolveColumnLabelIgnoreCase(cacheKey, 'code', resultJson[jsonCode], 'code', null, true)
      if (!portCode) {
        // 用解析值 匹配 英文名
        portCode = ColumnUtils.resolveColumnLabelIgnoreCase(cacheKey, 'englishName', resultJson[jsonCode], 'code', null, true)
        if (!portCode) {
          // 用解析值 匹配 中文名
          portCode = ColumnUtils.resolveColumnLabelIgnoreCase(cacheKey, 'chineseName', resultJson[jsonCode], 'code', null, true)
        }
      }
    }
    job[code] = portCode || ''
  }

  // 包装
  static mapperPacking(packingVal = '', job, resultJson, view) {
    let realPacking = resultJson.packing
    if (packingVal) { // 多单模式时 packingVal 有值
      realPacking = packingVal
    }
    let packingCode = ''
    if (!StrUtils.isEmpty(realPacking)) {
      // 用解析值 匹配 代码
      packingCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Packing, 'code', realPacking, 'code')
      if (!packingCode) {
        // 用解析值 匹配 英文名
        packingCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Packing, 'name', realPacking, 'code')
        if (!packingCode) {
          // 用解析值 匹配 中文名
          packingCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Packing, 'chineseName', realPacking, 'code')
          if (!packingCode) {
            const mapperKey = SystemConstants.OCR_MAPPER_TYPE_PACKING.code + '_' + view.useCase + '_' + realPacking
            const newMapperVal = view.packing.get(mapperKey)
            if (newMapperVal) {
              // 用映射值 匹配 代码
              packingCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Packing, 'code', newMapperVal, 'code')
              if (!packingCode) {
                // 用映射值 匹配 英文名
                packingCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Packing, 'name', newMapperVal, 'code')
                if (!packingCode) {
                  // 用映射值 匹配 中文名
                  packingCode = ColumnUtils.resolveColumnLabelIgnoreCase(TYPE_NAMES.basic_data_Packing, 'chineseName', newMapperVal, 'code')
                }
              }
            }
          }
        }
      }
      if (!packingVal) { // 多单模式时 packingVal 有值
        job.packing = packingCode || ''
      }
    }
    return packingCode
  }

  static getIdentificationTypes(source) {
    let recognitionType = SENDING_0.code
    let typeList = IDENTIFICATION_TYPE_DEFAULT
    // 控制下拉框默认内容
    // MBL识别提单、MBL邀请对单、HBL识别提单
    if ([INTELLIGENT_DOCUMENT_SOURCE_5.code, INTELLIGENT_DOCUMENT_SOURCE_6.code, INTELLIGENT_DOCUMENT_SOURCE_7.code, INTELLIGENT_DOCUMENT_SOURCE_16.code].includes(source)) {
      typeList = IDENTIFICATION_TYPE_3
      recognitionType = SENDING_2.code
    }
    // 远程订舱-海运
    else if (INTELLIGENT_DOCUMENT_SOURCE_REMOTE_SE.code === source) {
      typeList = [SENDING_0]
      recognitionType = SENDING_0.code
    }
    // 海运进口
    else if (INTELLIGENT_DOCUMENT_SOURCE_4.code === source) {
      typeList = [SENDING_1]
      recognitionType = SENDING_1.code
    }
    // 空运出口、远程订舱-空运
    else if ([INTELLIGENT_DOCUMENT_SOURCE_12.code, INTELLIGENT_DOCUMENT_SOURCE_REMOTE_AE.code].includes(source)) {
      typeList = [SENDING_4]
      recognitionType = SENDING_4.code
    }
    // 空运进口
    else if (INTELLIGENT_DOCUMENT_SOURCE_13.code === source) {
      typeList = [SENDING_5]
      recognitionType = SENDING_5.code
    }
    return { recognitionType, typeList }
  }
}

export default OcrUtils
